module.exports = __webpack_public_path__ + "static/media/683.5371825a.png";